// extracted by mini-css-extract-plugin
export default {"heroContent":"di4LKFG1KugaUJd8Xygn","sublead":"zwQBFdQcHqsjZPdf4HCE","heroImage":"jy75RThfx5wqRkl7Khpv"};